import { Component, OnInit, inject } from '@angular/core';
import {AnalyticsService} from '../../analytics/analytics.service';
import {PageTypes} from '../../analytics/enums/pageTypes';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: false,
})
export class PageNotFoundComponent implements OnInit {
  private analyticsService: AnalyticsService = inject(AnalyticsService);


  ngOnInit(): void {
    this.analyticsService.trackPageReady('Error Page', PageTypes.ERROR_PAGE);
  }

}
